function e({src:e,defaultExtension:t=`jpg`}){let n=e.match(/\.([0-9a-z]{1,5})$/);return n?n[1]:t}export{e as getFileExtension};
//# sourceMappingURL=get-file-extension.js.map